import React, {memo, Suspense, useCallback, useMemo} from 'react';
import {useSelector} from "react-redux";
import styled from 'styled-components'
import {
    ActivityTimelineContextProps,
    ActivityTimeline,
    ActivityTimelineContext,
    selectTimelineError,
    selectTimelineFiles,
    selectTimelineIsLoading,
} from "../../../../../components/v2/activity-timeline";
import {UploadFiles} from "../../../../../components/v2/upload-files";
import {deleteTimeLineItem} from "../../../../../store/timeline/actions";
import { useAppDispatch } from '../../../../../hooks/useAppDispatch/useAppDispatch'

const FilesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`

interface HrFilesTimelineProps {
    className?: string
    id: string | number
}

export const HrFilesTimeline: React.FC<HrFilesTimelineProps> = memo((props: HrFilesTimelineProps) => {
    const {id, className} = props;
    const dispatch = useAppDispatch();
    const timelineIsLoading = useSelector(selectTimelineIsLoading);
    const timelineError = useSelector(selectTimelineError);
    const timelineFiles = useSelector(selectTimelineFiles);
    const entityType = "hr";

    const deleteHrTimelineItem = useCallback((activityItem) => {
        dispatch(deleteTimeLineItem(activityItem))
    }, [])

    const defaultProps = useMemo(
        (): ActivityTimelineContextProps => ({
            card_id: id,
            card_type: entityType,
            deleteTimelineItem: deleteHrTimelineItem,
        }),
        [id],
    );

    return (
        <FilesContainer>
            <Suspense fallback={''}>
                <UploadFiles
                    entityType={entityType}
                    entityId={id}
                    url={`/api/${entityType}/request/${id}/add-file`}
                />
            </Suspense>
            <Suspense fallback={''}>
                <ActivityTimelineContext.Provider value={defaultProps}>
                    <ActivityTimeline
                        isLoading={timelineIsLoading}
                        items={timelineFiles}
                        error={timelineError}
                        className={className}
                        emptyMessage={'Нет прикрепленных файлов'}
                    />
                </ActivityTimelineContext.Provider>
            </Suspense>
        </FilesContainer>
    );
});

